import React from 'react';
import _ from 'lodash';
import Button from 'material-ui/Button';

export default class TakeExperimentForm {
	constructor(app){
		this.app = app;
		this.reset();
	}

	reset(){
		this.experiment = null;
	}

	async load({experimentId}){
		this.app.startLoadingForm(this);
		try{
			let experiment = await this.app.http.startExperiment({experimentId});

			experiment = {
				...this.app.EXPERIMENT_DEFAULTS,
				...experiment
			};

			if(_.isEmpty(experiment.definition)){
				experiment.definition = {screens: {id:'Experiment', isGroup: true, children:[{id:'Intro', elements:[]}]}};
			}

			this.app.mediaManager.setupS3({experimentId, researcherId:experiment.definition.researcherId});
			await this.app.mediaManager.getExperimentAssets(true);
			this.experiment = experiment;
			this.app.stopLoadingForm(this);
		}catch(e){
			console.log('ERROR',e);
			this.app.stopLoadingForm(this, e);

			if(e.message ==='You have already submitted a response for this experiment'){
				this.app.goToMessagePage({
					title: 'Experiment Already Completed',
					body: (<div>You have previously completed this experiment. Thank you for your participation.</div>)
				});
				return;
			}
			
			this.app.goToMessagePage({
				title: 'Unable to load experiment.',
				body: (<div>There was an error loading the experiment.</div>)
			});
			
		}
	}

	async submit({responseData, environment}){
		this.app.startLoadingForm(this);

		try{
			await this.app.http.sendExperimentResponse({response:responseData, environment:environment, experiment:this.experiment });
		}catch(e){
			this.app.stopLoadingForm(this, e);
			this.app.openDialog({
				label:'WAIT! There was an error saving your responses.',
				Component:() => (<div>
					Your response has not been saved.<br /><br />
					<Button variant="raised" onClick={
						e => {
							this.app.closeDialog();
							this.finish();
						}
					}>Try Again</Button>
				</div>)
			});
			return false;
		}

		this.app.stopLoadingForm(this);
		return true;
	}
}



// WEBPACK FOOTER //
// ./src/models/TakeExperimentForm.js